import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDromoImports as GetDromoImportsQuery,
    ImportIdentifier,
} from 'nutshell-graphql-types';

import GET_DROMO_IMPORTS from '../queries/get-dromo-imports.graphql';

type Variables = {
    importIdentifier: ImportIdentifier;
};

export const useGetDromoImports = (importIdentifier: ImportIdentifier) => {
    const {
        data,
        loading: isLoading,
        error,
        refetch,
    } = useQuery<GetDromoImportsQuery, Variables>(GET_DROMO_IMPORTS, {
        variables: {importIdentifier},
        fetchPolicy: 'cache-and-network',
    });

    const dromoImports = data ? data.dromoImports : null;

    return {
        dromoImports,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
